import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Route, Switch} from 'react-router-dom';
import {ConnectedRouter} from 'connected-react-router'
import {
  Provider as KeepAliveProvider,
} from '../keep';

// import * as serviceWorker from './serviceWorker';


import configureStore, {history} from './store/index';

// export const store = configureStore();

let keepAliveProvider=null;

export function unKeepCache(keepId){
  if(keepId)
    keepAliveProvider.unCache(keepId);
  else
    keepAliveProvider.unCacheAll();
}

const Index = ({component,reducers,sagas}) =>{
  const store = configureStore({reducers,sagas});
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        {/* 放在这里才不会影响路由 */}
        <KeepAliveProvider ref={(ref) => keepAliveProvider = ref}>  
          <Switch>
            <Route path="/" component={component}/>
          </Switch>
        </KeepAliveProvider>
      </ConnectedRouter>
    </Provider>
  );
};



export default function Root(app,reducers,sagas){
  const rootEl = document.getElementById('app-site');

  const Component =  ()=> <Index component={app} reducers={reducers} sagas={sagas} />;

  // Create a reusable render method that we can call more than once
  let render = () => {
    // Dynamically import our main App component, and render it
    ReactDOM.render(
      <Component/>,
      rootEl
    );
  };
  
  // if (module.hot) {
  //   module.hot.accept('./Root', () => {
  //     render(
  //       <Component />,
  //       rootEl
  //     );
  //   });
  // }
  
  render();
}


// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
